var animateScrollOptions = {
	duration: 700,
	easing: 'easeOutQuart',
};

var gotoSectionBiofarma = document.querySelectorAll('.js-goto-section-biofarma');
Array.prototype.forEach.call(gotoSectionBiofarma, function(el) {
	el.addEventListener('click', function(e) {
		new AnimateScroll(document.querySelector('.js-section-biofarma'), animateScrollOptions);
	});
});

var gotoSectionProdej = document.querySelectorAll('.js-goto-section-prodej');
Array.prototype.forEach.call(gotoSectionProdej, function(el) {
	el.addEventListener('click', function(e) {
		new AnimateScroll(document.querySelector('.js-section-prodej'), animateScrollOptions);
	});
});

var gotoSectionBourarna = document.querySelectorAll('.js-goto-section-bourarna');
Array.prototype.forEach.call(gotoSectionBourarna, function(el) {
	el.addEventListener('click', function(e) {
		new AnimateScroll(document.querySelector('.js-section-bourarna'), animateScrollOptions);
	});
});

var gotoSectionKontakt = document.querySelectorAll('.js-goto-section-kontakt');
Array.prototype.forEach.call(gotoSectionKontakt, function(el) {
	el.addEventListener('click', function(e) {
		new AnimateScroll(document.querySelector('.js-section-kontakt'), animateScrollOptions);
	});
});
